import React from 'react';
import { Printer, FileScan, FolderSearch, Receipt, ClipboardCheck, HardDrive } from 'lucide-react';

// Phrased as the questions we are asking, not as features. Nothing here is
// shipped, and the copy must stay that way until the healthcare plan is real.
const CARDS = [
  {
    icon: Printer,
    title: 'Referral intake from fax portals',
    body:
      'How do referrals arrive, who downloads them, and what happens when one fax bundle covers several patients? We want to know who separates the pages, how long it takes, and what goes wrong.',
  },
  {
    icon: FileScan,
    title: 'Getting scans into the right chart',
    body:
      'After a document is scanned or downloaded, what does it take to attach it to the correct patient record in the EHR? How is the match confirmed, and how often does something land in the wrong chart?',
  },
  {
    icon: FolderSearch,
    title: 'Records requests and release of information',
    body:
      'When a request comes in, how are the right documents found, assembled, checked, and sent? Where does the time go, and what gets delayed?',
  },
  {
    icon: Receipt,
    title: 'Billing, EOBs, and payer correspondence',
    body:
      'How do explanation of benefits documents and payer letters get from a portal or the mail to the person and the system that needs them? What is re-keyed by hand?',
  },
  {
    icon: ClipboardCheck,
    title: 'Prior authorizations and insurance paperwork',
    body:
      'What documents have to be gathered for an authorization, where do they live, and how many hands touch them before the request goes out?',
  },
  {
    icon: HardDrive,
    title: 'Shared drives and naming',
    body:
      'Outside the EHR, how are files named and filed on shared drives, and how do people find them a year later? What has the practice already tried, and why did it or did it not stick?',
  },
];

const WhatWeAreStudying = () => {
  return (
    <section id="workflows" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          What we are studying
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          These are the document workflows practices have told us take the most time. If yours is
          not on the list, that is exactly what the interview is for.
        </p>
      </div>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {CARDS.map(({ icon: Icon, title, body }) => (
          <div key={title} className="bg-apple-700/30 backdrop-blur-md rounded-2xl border border-apple-600/30 p-6">
            <div className="w-10 h-10 rounded-xl bg-sortio-primary/15 flex items-center justify-center mb-4">
              <Icon className="text-sortio-primary" size={20} />
            </div>
            <h3 className="text-lg font-medium text-apple-50 mb-2">{title}</h3>
            <p className="text-apple-300 text-sm leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatWeAreStudying;
